module.exports = __webpack_public_path__ + "img/Vector.eb8f69e0.svg";